import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
  useTheme,
  styled,
  Pagination,
  TextField,
  InputAdornment,
  IconButton,
  ButtonGroup,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import variables from "../../../assets/styles/variables.module.scss";
import CreateMultiAgent from "../CreateMultiAgent";
import MultiAgentCard from "../../../Shared-ui/SharedComponents/Cards/MultiAgentCard";
import { useDispatch, useSelector } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { TEAMS } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { MultiAgent } from "../../../Shared-ui/Types/MultiAgent";
import Confirm from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import SearchIcon from "@mui/icons-material/Search";
import Agent_emptystateimage from "../../../assets/images/Agents_emptystateimage.svg";
import Menu from "@mui/material/Menu";
import { MenuItem as MenuItemComponent } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { NumberDomain } from "recharts/types/util/types";
import { set } from "date-fns";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// Styled Button
const StyledColorButton = styled(Button)(({ theme }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
  textTransform: "capitalize",
  fontWeight: 400,
  borderRadius: "8px",
  height: "40px",
  whiteSpace: "nowrap",
}));

const MultiAgents: React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  
  // State for create multi-agent dropdown
  const [createMultiAgentOpen, setCreateMultiAgentOpen] = useState(false);
  const [createMultiAgentAnchorEl, setCreateMultiAgentAnchorEl] = useState<null | HTMLElement>(null);

  const [multiAgents, setMultiAgents] = useState<MultiAgent[]>([]);
  const [multiAgentsAll, setMultiAgentsAll] = useState<MultiAgent[]>([]);
  const [multiAgent, setMultiAgent] = useState<MultiAgent | null>(null);
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({
    show: false,
  });
  const [searchText, setSearchText] = useState<string>("");
  // State for opening dialog

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(8);
  const [totalMultiAgents, setTotalMultiAgents] = useState(0);
  const prevPage = useRef<number>(page);
  const pageLimitRef = useRef(8);



  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [filterType, setFilterType] = useState<string>("All Agents");
  const [filteredMultiAgents, setFilteredMultiAgents] = useState<MultiAgent[]>([]);
  const loaderStatus = useSelector((state: any) => state.LoaderReducer);
  const isFirstRender = useRef(true);


  // useEffect(() => {
  //   getMultiAgents();
  // }, []);


  useEffect(() => {
    if (prevPage.current !== page) {
      getMultiAgents();
      prevPage.current = page;
    }
  }, [page]);

  useEffect(() => {
    if (!searchText) {
      setPage(1);
      getMultiAgents();
    }

  }, [searchText]);

  const getMultiAgents = async (filter?: string, searchText?: string) => {
    try {
      dispatch(StartLoading("MultiAgent"));
      var url = `${TEAMS}?page=${page}&page_size=${limit}`
      if (filter) {
        url = `${TEAMS}?skip=${0}&limit=${limit}&filter=${filter}`;
      }
      if (filter) {
        url += `&filter=${filter}`;
      } else if (searchText) {
        url += `&search=${searchText}`;
      }
      const data = await BaseInstance.get(url).then((res) => res?.data);
      // data?.items?.sort(
      //   (a: { created_at: string }, b: { created_at: string }) =>
      //     new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      // );
      setTotalMultiAgents(data.pagination.total || 0);
      setMultiAgents(data.items || []);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading("MultiAgent"));
    }
  };
  const updateMultiAgentStatus = async (agent: MultiAgent) => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(
        `${TEAMS}/${agent.id}/toggle-status`
      ).then((res) => res?.data);
      getMultiAgents();
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const deleteAgent = async (agent: MultiAgent) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading());
      const data = await BaseInstance.delete(`${TEAMS}/${agent.id}`).then(
        (res) => res?.data
      );
      getMultiAgents(filterType);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const confirmDelete = (agent: MultiAgent) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete the Multi-Agent? This action cannot be undone.",
      varient: "delete",
      functionName: deleteAgent,
      functionParam: agent,
    });
  };
  const handleClose = () => {
    setOpen(false);
    getMultiAgents();
    setMultiAgent(null);
  };

  const editMultiAgent = (multiAgent: MultiAgent) => {
    setMultiAgent(multiAgent);
    setOpen(true);
  };

  const handleOpen = () => setOpen(true);

  // Create multi-agent dropdown handlers
  const handleCreateMultiAgentClick = (event: React.MouseEvent<HTMLElement>) => {
    setCreateMultiAgentAnchorEl(event.currentTarget);
    setCreateMultiAgentOpen(true);
  };

  const handleCreateMultiAgentClose = () => {
    setCreateMultiAgentOpen(false);
    setCreateMultiAgentAnchorEl(null);
  };

  const handleVisualBuilder = () => {
    navigate('/multi-agents/create-multi-agent');
    handleCreateMultiAgentClose();
  };

  const handleClassicBuilder = () => {
    setOpen(true);
    handleCreateMultiAgentClose();
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  const handleSearch = () => {
    setPage(1);
    getMultiAgents(undefined, searchText);

  };

  const handleFilterPopUp = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClick = (option: number) => {
    if (option == 0) {
      getMultiAgents("all");
      setFilterType("All agents")
    } else if (option == 1) {
      getMultiAgents("owned");
      setFilterType("Created by me")
    } else if (option == 2) {
      getMultiAgents("shared");
      setFilterType("Shared")
    }
    setAnchorEl(null);
  };

  const getFilterIcon = (type: string) => {
    switch (type) {
      case "Created by me":
        return <PersonOutlineIcon sx={{ fontSize: 20 }} />;
      case "Shared":
        return <ShareOutlinedIcon sx={{ fontSize: 20 }} />;
      default:
        return <PeopleOutlineIcon sx={{ fontSize: 20 }} />;
    }
  };

  return (
    <Box>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
          flexDirection: { xs: "column", sm: "column", md: "row" },
          gap: { xs: 2, sm: 2, md: 0 },
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography>Filter by:</Typography>
            <Button
              onClick={handleFilterPopUp}
              endIcon={<KeyboardArrowDownIcon />}
              startIcon={getFilterIcon(filterType)}
              sx={{
                textTransform: "none",
                color: "text.primary",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
                display: "flex",
                alignItems: "center",
                "& .MuiButton-startIcon": {
                  marginRight: 0.5,
                },
              }}
            >
              {filterType}
            </Button>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            sx={{
              "& .MuiPaper-root": {
                width: 220,
                boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                borderRadius: "8px",
                mt: 1,
              },
            }}
          >
            <MenuItemComponent onClick={() => handleFilterClick(0)}>
              <PeopleOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
              <Box sx={{ lineHeight: 0 }}>
                <Typography sx={{ lineHeight: "16px" }}>All Agents</Typography>
                <Typography variant="caption" color="text.secondary">
                  View all available agents
                </Typography>
              </Box>
            </MenuItemComponent>
            <MenuItemComponent onClick={() => handleFilterClick(1)}>
              <PersonOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
              <Box sx={{ lineHeight: 0 }}>
                <Typography sx={{ lineHeight: "16px" }}>
                  Created by me
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Agents I created
                </Typography>
              </Box>
            </MenuItemComponent>
            <MenuItemComponent onClick={() => handleFilterClick(2)}>
              <ShareOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
              <Box sx={{ lineHeight: 0 }}>
                <Typography sx={{ lineHeight: "16px" }}>Shared</Typography>
                <Typography variant="caption" color="text.secondary">
                  Agents shared
                </Typography>
              </Box>
            </MenuItemComponent>
          </Menu>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "100%", md: "auto" },
          }}
        >
          <TextField
            placeholder="Search Multi-Agent"
            variant="outlined"
            size="small"
            sx={{
              width: { xs: "100%", sm: "350px" },
              flex: { xs: 1, sm: 1, md: "none" },
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            value={searchText}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearch} // your custom function
                    edge="end"
                    size="small"
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <ButtonGroup
            variant="contained"
            sx={{
              borderRadius: { sm: "8px", xs: "4px" },
              overflow: "hidden",
              boxShadow: "none",
              "& .MuiButton-root": {
                color: variables.whiteColor,
                textTransform: "capitalize",
                fontWeight: "400",
                whiteSpace: "nowrap",
                backgroundColor: variables.primaryButton,
                "&:hover": {
                  backgroundColor: variables.primaryColor,
                },
              },
              "& .MuiButtonGroup-firstButton": {
                borderRight: `1px solid ${variables.whiteColor}`,
              },
            }}
            size={isSmallScreen ? "small" : "large"}
          >
            <StyledColorButton
              startIcon={<AddIcon />}
              aria-haspopup="menu"
              onClick={handleClassicBuilder}
              // onClick={handleCreateMultiAgentClick}
              sx={{
                "& .MuiButton-startIcon": {
                  mr: { xs: 0, sm: 1 },
                },
              }}
            >
              {!isSmallScreen && "Create Multi-Agent"}
            </StyledColorButton>

            <StyledColorButton
              size="small"
              aria-controls={createMultiAgentOpen ? "create-agent-menu" : undefined}
              aria-expanded={createMultiAgentOpen ? "true" : undefined}
              aria-haspopup="menu"
              onClick={handleCreateMultiAgentClick}
            >
              <ArrowDropDownIcon />
            </StyledColorButton>
          </ButtonGroup>
          
          <Popper
            open={createMultiAgentOpen}
            anchorEl={createMultiAgentAnchorEl}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
            sx={{ zIndex: 1500 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCreateMultiAgentClose}>
                    <MenuList
                      autoFocusItem={createMultiAgentOpen}
                      id="create-multi-agent-menu"
                      aria-labelledby="create-multi-agent-button"
                    >
                      <MenuItem onClick={handleVisualBuilder}>
                        Visual Builder
                      </MenuItem>
                      <MenuItem onClick={handleClassicBuilder}>
                        Classic Builder
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Box>

      {/* Agent Cards */}
      {multiAgents.length > 0 && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xl: "1fr 1fr 1fr 1fr",
              lg: "1fr 1fr 1fr 1fr",
              md: "1fr 1fr 1fr",
              sm: "1fr 1fr",
            },
            gap: 3,
            gridAutoRows: "1fr",
          }}
        >
          {multiAgents.map((agent, index) => (
            <MultiAgentCard
              key={index}
              multiAgent={agent}
              deleteFunc={confirmDelete}
              editFun={editMultiAgent}
              statusChangeFunc={updateMultiAgentStatus}
            />
          ))}
        </Box>
      )}
      {multiAgents.length === 0 && totalMultiAgents === 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 6,
            // mb: 6,
          }}
        >

          {loaderStatus.isLoading === false &&
            loaderStatus.pageName === "MultiAgent" && (
              <>
                <img
                  src={Agent_emptystateimage}
                  alt="No Agents"
                  style={{ width: 120, height: "auto" }}
                />
                <Typography variant="h6" color="text.secondary">
                  No Multi-Agents Found
                </Typography>
              </>

            )}
          {loaderStatus.isLoading === true &&
            loaderStatus.pageName === "MultiAgent" && (
              <>
                <img
                  src={Agent_emptystateimage}
                  alt="No Agents"
                  style={{ width: "200px", marginBottom: "20px" }}
                />
                <Typography variant="h6" color="text.secondary">
                  Multi-Agents loading...
                </Typography>
              </>

            )}
        </Box>
      )}


      {/* Pagination */}
      {totalMultiAgents > limit && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Pagination
            count={Math.ceil(totalMultiAgents / limit)}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}

      {/* Create Team Dialog */}
      {/* Create Team Dialog */}
      <CreateMultiAgent
        open={open}
        handleClose={handleClose}
        multiAgent={multiAgent}
      />
      <ConfirmPopup details={confirmPopupData} />
    </Box>
  );
};

export default MultiAgents;
